import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { Container } from '@mui/material';

import { IMaterial } from "../../../types/material";

import { useUserContext } from "../../../contexts/userContext";

import PermissionGate from "../../permissionGate";
import Navigation from "../../header";
import { Icons } from "../../icons";
import MaterialDetailsForm from "../../forms/materialDetailsForm";

const blankMaterial: IMaterial = {
	id: undefined,
	material: "",
	category: "",
	isHazardous: false,
	isActive: true
};

const MaterialAdd = () => {
	const userContext = useUserContext();
	const [formFields, setFormFields] = useState<IMaterial>(blankMaterial);

	useEffect(() => {
	}, [])

	const reset = () => {
		setFormFields(JSON.parse(JSON.stringify(blankMaterial)));
	}

	return (
		<div className="hwi-material-add">
			<Navigation></Navigation>
			<Container maxWidth="lg" className="route-container">
				<PermissionGate permission={userContext.permissions?.canManageMaterials}>
					<section className="management-page-header">
						<div className="title">
							<NavLink to="/material">
								<Icons.GoBack fill="#9399ad" height="24px"></Icons.GoBack>
							</NavLink>
							Add Material
						</div>
					</section>
					<section className="management-page-form">
						<MaterialDetailsForm action="add" details={formFields} reloadData={reset} ></MaterialDetailsForm>
					</section>
				</PermissionGate>
			</Container>
		</div>
	);
};

export default MaterialAdd;